export function generateHelpContent({ description, defaultValue }) {
  let content = description;

  if (defaultValue) {
    content += ` The default value for this rule is: ${defaultValue}.`;
  }
  return content;
}
